/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ESickNoteIdentityCreateSchema } from '../models/ESickNoteIdentityCreateSchema';
import type { ESickNoteIdentityDetailSchema } from '../models/ESickNoteIdentityDetailSchema';
import type { ESickNoteIdentityUpdateSchema } from '../models/ESickNoteIdentityUpdateSchema';
import type { ESickNotePingSchema } from '../models/ESickNotePingSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EsickNoteIdentitiesApi {
    /**
     * Create Esick Note Identity
     * Register an IČPE at ČSSZ (ČSSZ VytvorIcpe) and assign the doctors allowed to act under it. At least one doctor is required, and the caller is not added implicitly. Required Permission: create_esick_note
     * @returns ESickNoteIdentityDetailSchema Created
     * @throws ApiError
     */
    public static esickNoteIdentityCreateEsickNoteIdentityPost({
        requestBody,
    }: {
        requestBody: ESickNoteIdentityCreateSchema,
    }): CancelablePromise<ESickNoteIdentityDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/identities/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Esick Note Identity List
     * List every ČSSZ prescriber identity (IČPE) in the company, active and invalidated, including ones not yet assigned to a doctor, so an unassigned IČPE can be found and claimed. Their ids are required by every ČSSZ query endpoint. Pass user_id to list only the identities assigned to that user, is_active to list only active (true) or only invalidated (false) identities. Required Permission: create_esick_note
     * @returns ESickNoteIdentityDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteIdentityGetEsickNoteIdentityListGet({
        userId,
        isActive,
    }: {
        /**
         * Return only the identities assigned to this user
         */
        userId?: (string | null),
        /**
         * true returns only active identities, false only invalidated ones; omitted returns both
         */
        isActive?: (boolean | null),
    }): CancelablePromise<Array<ESickNoteIdentityDetailSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/identities/',
            query: {
                'user_id': userId,
                'is_active': isActive,
            },
        });
    }
    /**
     * Discover Esick Note Identities
     * Import the IČPE registrations ČSSZ already holds for the company's IČO (ČSSZ VratIcpe). ČSSZ creates a main IČPE for every IČO on its own, so this is the first step before registering any new one. Imported registrations have no doctors assigned. Every IČO in the company's insurance settings is queried. Required Permission: create_esick_note
     * @returns ESickNoteIdentityDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteIdentityDiscoverEsickNoteIdentitiesPost(): CancelablePromise<Array<ESickNoteIdentityDetailSchema>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/identities/discovery/',
        });
    }
    /**
     * Ping Esick Note
     * Verify connectivity to ČSSZ for this identity (ČSSZ IkreDpnTestService). Required Permission: create_esick_note
     * @returns ESickNotePingSchema OK
     * @throws ApiError
     */
    public static esickNoteIdentityPingEsickNoteGet({
        identityId,
    }: {
        identityId: string,
    }): CancelablePromise<ESickNotePingSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/identities/{identity_id}/ping/',
            path: {
                'identity_id': identityId,
            },
        });
    }
    /**
     * Delete Esick Note Identity
     * Invalidate the IČPE at ČSSZ (ČSSZ ZneplatniIcpe) and deactivate it locally. Irreversible - ČSSZ cannot reactivate an invalidated IČPE. Required Permission: create_esick_note
     * @returns ESickNoteIdentityDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteIdentityDeleteEsickNoteIdentityDelete({
        identityId,
    }: {
        identityId: string,
    }): CancelablePromise<ESickNoteIdentityDetailSchema> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/esick-notes/identities/{identity_id}/',
            path: {
                'identity_id': identityId,
            },
        });
    }
    /**
     * Update Esick Note Identity
     * Update an IČPE: its registration at ČSSZ (ČSSZ VytvorIcpe with Icpe), the doctors allowed to act under it, and the settings row it communicates under. The whole entity is replaced. On the primary IČPE, whose registration ČSSZ owns, only the doctors and the settings row are applied and nothing is sent to ČSSZ. Required Permission: create_esick_note
     * @returns ESickNoteIdentityDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteIdentityUpdateEsickNoteIdentityPut({
        identityId,
        requestBody,
    }: {
        identityId: string,
        requestBody: ESickNoteIdentityUpdateSchema,
    }): CancelablePromise<ESickNoteIdentityDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/identities/{identity_id}/',
            path: {
                'identity_id': identityId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Esick Note Identity
     * Get one active ČSSZ prescriber identity (IČPE) of the company, including ones not assigned to the caller. Required Permission: create_esick_note
     * @returns ESickNoteIdentityDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteIdentityGetEsickNoteIdentityGet({
        identityId,
    }: {
        identityId: string,
    }): CancelablePromise<ESickNoteIdentityDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/identities/{identity_id}/',
            path: {
                'identity_id': identityId,
            },
        });
    }
}
